function _(t,e,n){var c=t(8),r=Object.keys;e.exports=function(t){return r(c(t)?Object(t):t)}}
//# sourceMappingURL=shim.min.js.map